import { connect } from 'react-redux'

import { pinComment, unpinComment } from '../../actions/comments'
import AreaActivityItem from '../../components/area-activities/area-activity-item'

function mapStateToProps (state, ownProps) {
  const areaActivity = state.areaActivities[ownProps.activityId]

  const activity = state[areaActivity.activity.schema][areaActivity.activity.id]

  if (areaActivity.activityType === 'Comment') {
    return {
      activity,
      user: state.users[activity.user]
    }
  } else {
    return {
      activity,
      technician: state.users[activity.technician]
    }
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const commentId = getCommentId(ownProps.activityId)

  return {
    onPin () {
      dispatch(pinComment(commentId))
    },
    onUnpin () {
      dispatch(unpinComment(commentId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AreaActivityItem)

function getCommentId (activityId) {
  return activityId.split('-')[1]
}



// WEBPACK FOOTER //
// ./src/containers/area-activities/area-activity-item-container.js